export const footerItemStyle = {
    paddingBottom: {
        "md": 2,
        "xs": 2
    }
}